import container from './lib/container'

export default {
  install (Vue) {
    // It's a Proxy, babe :)
    Vue.prototype.$http = new Proxy({
      // returns an object
      make: (name, payload) => {
        const Inst = container.get(name)
        if (!Inst) {
          throw new Error(`${name} is not registered`)
        }
        return new Inst(payload)
      }
    }, {
      // returns a class
      get (target, name) {
        if (!this.hasOwnProperty(name) && container.has(name)) {
          return container.get(name)
        } else {
          return target[name]
        }
      }
    })
  }
}
